import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

type NoticeTone = 'destructive' | 'success' | 'warning' | 'info';

const noticeVariants = cva('rounded-md border px-3 py-2 text-sm', {
  variants: {
    tone: {
      destructive: 'border-destructive-border bg-destructive-subtle text-destructive',
      success: 'border-success-border bg-success-subtle text-success',
      warning: 'border-warning-border bg-warning-subtle text-warning',
      info: 'border-info-border bg-info-subtle text-info'
    }
  }
});

interface NoticeProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'role'> {
  tone: NoticeTone;
  children: React.ReactNode;
  className?: string;
}

function Notice({ tone, children, className, ...props }: NoticeProps) {
  return (
    <div role={tone === 'destructive' ? 'alert' : 'status'} className={cn(noticeVariants({ tone }), className)} {...props}>
      {children}
    </div>
  );
}

export { Notice };
export type { NoticeProps, NoticeTone };
